<!-- eslint-disable vue/valid-v-for -->
<template>
  <div class="login-layout" :style="cssVars">
    <div class="login-layout-ant">
      <LeftRow v-if="!loading"/>
      <div class="login-layout-ant-lay">
        <div class="login-layout-right login-layout-ant-lay-content">
          <div class="login-layout-right-form">
            <a-spin v-if="loading" style="margin-left: 40%" />
            <div v-else>
              <div class="title">
                <img :src="logoUi.imgSrc || ''" alt="" />
                <span style="flex-shrink: 0;">{{ logoUi.test || "" }}</span>
              </div>
              <div class="text" v-if="isForgetPassword">{{ isResetPassword ? '重置密码' : '忘记密码' }}</div>
              <ZnLogin v-if="!isForgetPassword" />
              <resetPsw v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// import { message } from 'ant-design-vue';

// import api from '@/api';
// import { post } from '@/utils/http';

import { getLogo, hasYjbParameter } from '@/utils/intConfiguration';
import { getMicroAppList } from '@/micro/index';
import { getDisposition } from '@/utils/accessResources';
import LeftRow from './components/leftRow.vue';
import ZnLogin from './components/login/index.vue';
// eslint-disable-next-line import/no-unresolved
import resetPsw from './components/resetPsw/index.vue';

export default {
  name: 'OmsMicroLogin',
  components: {
    LeftRow,
    ZnLogin,
    resetPsw,
  },
  data() {
    return {
      loading: true,
      microAppList: getMicroAppList(),
      logoUi: null,
    };
  },
  computed: {
    cssVars() {
      const vars = {};
      if (this.logoUi && this.logoUi.themeColor && this.logoUi.themeColor.toUpperCase() !== '#4D4DFF') {
        vars['--themeColor'] = this.logoUi.themeColor;
      }
      return vars;
    },
    env() {
      let env = false;
      try {
        env = process.env.NODE_ENV === 'development';
      } catch (e) {
        env = false;
      }
      return env;
    },
    isForgetPassword() {
      return this.$store.state.login.isForgetPassword;
    },

    isResetPassword() {
      return this.$store.state.login.isResetPassword;
    },
  },
  mounted() {
    const self = this;
    if (window.location.hostname.toString().includes('skydome') && hasYjbParameter()) {
      self.logoUi = getLogo();
      self.loading = false;
    } else {
      getDisposition().finally(() => {
        self.logoUi = getLogo();
        console.log(self.logoUi);

        self.loading = false;
      });
    }
  },
  methods: {
  },
};
</script>

<style lang="less" >
.login-layout {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;

  .ant-layout.ant-layout-has-sider {
    width: 100%;
    height: 100%;
  }

  .ant-tabs-bar {
    border-bottom: none;
    margin: 0;
  }

  .ant-tabs-tab {
    font-size: 18px;
    padding: 12px 0;
  }

  &-ant {
    width: 100%;
    height: 100%;
    flex-direction: row;
    box-sizing: border-box;
    display: flex;
    flex: auto;
    min-height: 0;
    background: #f0f2f5;

    &-lay {
      box-sizing: border-box;
      display: flex;
      flex: auto;
      flex-direction: column;
      min-height: 0;
      background: #f0f2f5;

      &-content {
        flex: auto;
        min-height: 0;
      }
    }
  }

  &-right {
    position: relative;
    background: #fff;

    &-form {
      width: 44%;
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate3d(-50%, -50%, 0);
      min-width: 360px;

      .title {
        width: 100%;
        height: 78px;
        position: relative;
        text-align: left;
        line-height: 78px;
        // padding-left: 133px;
        font-size: 16px;
        font-weight: normal;
        letter-spacing: 0em;
        color: #606266;
        margin-bottom: 28px;
        padding-top: 8px;
        display: flex;
        img {
          height: 70px;
          display: block;
          // position: absolute;
          // top: 50%;
          // left: 0;
          // transform: translateY(-50%);
        }
        span {
          padding-left: 12px;
        }
      }

      .text {
        margin: 52px 0 10px 0;
        font-family: PingFangSC-Semibold;
        font-size: 28px;
        font-weight: 600;
        //letter-spacing: 7px;
        color: #2D3968;
        text-align: left;
      }
    }
  }
}
</style>
